import { __awaiter, __decorate } from "tslib";
import { Connect, ConnectConfig, defaultConnectConfig, Session, SocketReconnectStrategy, } from '@genesislcap/foundation-comms';
import { baseLayerLuminance, StandardLuminance } from '@microsoft/fast-components';
import { FASTElement, customElement, observable } from '@microsoft/fast-element';
import { Container, inject, Registration } from '@microsoft/fast-foundation';
import { DefaultRouteRecognizer } from '@microsoft/fast-router';
import * as Components from '../components';
import { MainRouterConfig } from '../routes';
import { MainStyles as styles } from './main.styles';
import { DynamicTemplate as template, LoadingTemplate, MainTemplate } from './main.template';
const name = 'foundation-entity-management';
/**
 * @public
 */
let MainApplication = class MainApplication extends FASTElement {
    constructor() {
        super(...arguments);
        this.ready = false;
        this.data = null;
    }
    connectedCallback() {
        this.registerDIDependencies();
        super.connectedCallback();
        this.loadRemotes();
    }
    onLuminanceToggle() {
        baseLayerLuminance.setValueFor(this.provider, baseLayerLuminance.getValueFor(this.provider) === StandardLuminance.DarkMode
            ? StandardLuminance.LightMode
            : StandardLuminance.DarkMode);
    }
    loadRemotes() {
        return __awaiter(this, void 0, void 0, function* () {
            yield Components.loadRemotes();
            this.ready = true;
        });
    }
    selectTemplate() {
        return this.ready ? MainTemplate : LoadingTemplate;
    }
    registerDIDependencies() {
        this.container.register(Registration.transient(DefaultRouteRecognizer, DefaultRouteRecognizer), 
        /**
         * Register custom configs for core services and micro frontends. Note this can also be done via
         * provideDesignSystem().register(...) if preferred.
         *
         * Registration.instance<CredentialManagerConfig>(CredentialManagerConfig, {
         *  ...defaultCredentialManagerConfig,
         *  cookie: {
         *    ...defaultCredentialManagerConfig.cookie,
         *    path: '/login',
         *  },
         * }),
         */
        Registration.instance(ConnectConfig, Object.assign(Object.assign({}, defaultConnectConfig), { connect: Object.assign(Object.assign({}, defaultConnectConfig.connect), { heartbeatInterval: 15000 }), reconnect: Object.assign(Object.assign({}, defaultConnectConfig.reconnect), { reconnectAttempts: 15, reconnectStrategy: SocketReconnectStrategy.Exponential }) })));
    }
};
__decorate([
    inject(MainRouterConfig)
], MainApplication.prototype, "config", void 0);
__decorate([
    Connect
], MainApplication.prototype, "connect", void 0);
__decorate([
    Session
], MainApplication.prototype, "session", void 0);
__decorate([
    Container
], MainApplication.prototype, "container", void 0);
__decorate([
    observable
], MainApplication.prototype, "provider", void 0);
__decorate([
    observable
], MainApplication.prototype, "ready", void 0);
__decorate([
    observable
], MainApplication.prototype, "data", void 0);
MainApplication = __decorate([
    customElement({
        name,
        template,
        styles,
    })
], MainApplication);
export { MainApplication };
